import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  PermissionStateType,
  selectedPermissionData,
  updateFunctionalityPayload,
} from '../types/permissions.types'
import { FieldPermissions } from '../types/fieldPermissions'
const initialState: PermissionStateType = {
  selected: null,
  fieldPermissions: {},
}

const permissionSlice = createSlice({
  name: 'permissions',
  initialState: initialState,
  reducers: {
    getPermissionById: (state: PermissionStateType, _action) => {
      return state
    },

    getFieldPermissions: (state: PermissionStateType) => {
      return state
    },

    updateFieldPermissions: (
      state,
      action: PayloadAction<FieldPermissions>
    ) => {
      state.fieldPermissions = action.payload
    },

    updatePermissionState: (
      state,
      action: PayloadAction<selectedPermissionData>
    ) => {
      state.selected = action.payload
    },
    updatePermissionsAction: (
      state: PermissionStateType,
      _action: PayloadAction<updateFunctionalityPayload>
    ) => {
      return state
    },
  },
})

export const {
  getPermissionById,
  updatePermissionState,
  updatePermissionsAction,
  getFieldPermissions,
  updateFieldPermissions,
} = permissionSlice.actions
export default permissionSlice.reducer
